// ============================================================================
// Slugs reservados para la landing pública multi-liga
// ============================================================================
// Estos segmentos NO pueden usarse como slug de liga porque colisionarían con
// rutas del app en `liga.ajupam.ar/<segment>`.
//
// La lista debe mantenerse sincronizada con `public._is_slug_reserved(text)`
// en la migración `20260702_v6_11_14_00_public_hall_of_fame.sql`. El backend
// tiene la última palabra vía CHECK constraint en `leagues.slug`.
// ============================================================================

export const RESERVED_SLUGS = new Set<string>([
  'admin', 'admin-liga', 'admin-predios', 'administracion',
  'login', 'logout', 'signin', 'signup', 'register', 'auth',
  'inscripcion', 'inscripciones', 'pre-inscripcion', 'preinscripcion',
  'campeones', 'playoffs', 'muro-fama', 'muro-de-la-fama', 'hall-of-fame',
  'sponsors', 'patrocinadores',
  'api', 'platform', 'plataforma',
  'reglamento', 'contacto', 'privacidad', 'terminos',
  'liga', 'ligas',
  'partidos', 'partidos-liga', 'matches', 'standings', 'tabla',
  'agenda', 'fixture', 'perfil', 'mi-equipo',
  // v6.11.66 — destinos de las notificaciones (utils/notificationTargets.ts)
  'partido', 'nuevo-partido', 'match-center', 'convenios',
  'join', 'suplencia', 'preview', 'sponsor',
  'abridor', 'abridor-control',
  // v6.11.208 — el rol se llama "juez de cancha" (antes "abridor"): su panel vive en
  // `/juez` (`/abridor` queda como alias). Espejo de `_is_slug_reserved`.
  'juez', 'juez-control', 'jueces',
  'equipos', 'teams', 'jugadores', 'players',
  'encuesta', 'encuestas',
  'recepcion', 'recepcion-mesa',
  // v6.11.188 — sitio de control de acceso. SIN esto, `/verificacion` es un
  // segmento raíz kebab-case y `isRootLevelLeagueSlug` lo trata como slug de liga.
  'verificacion', 'verificaciones',
  // v6.11.188 — `/v/:token` (QR de la credencial). Son dos segmentos y no
  // colisiona con el catch-all de slug raíz, pero una liga con slug 'v' haría
  // ambigua la ruta para cualquiera que la lea.
  'v',
  // v6.11.225 — página del evento intermedio (`/evento/:id`). Espejo de `_is_slug_reserved`.
  'evento', 'eventos',
  // v6.11.372 — inscripción al sorteo en sede (`/sorteo/<código>`). Espejo de `_is_slug_reserved`.
  'sorteo', 'sorteos',
  'opener', 'abridor', 'referi', 'arbitro', 'arbitros',
  'account', 'cuenta', 'dashboard', 'settings', 'ajustes', 'profile', 'perfil',
  'dev', 'index', 'home', 'root', 'public', 'app',
  'estadisticas', 'stats',
  '_next', '__', 'favicon', 'robots', 'sitemap', 'manifest',
  'service-worker', 'sw', 'static', 'assets',
]);

export const isReservedSlug = (slug: string | null | undefined): boolean => {
  if (!slug) return false;
  return RESERVED_SLUGS.has(slug.toLowerCase());
};
